import React, { useState, useEffect, useMemo } from 'react';
import { isCarLine } from '../consumptionsAndEmissions/utils';
import { CAR_BY_CODE_QUERY } from './queries/carByCodeQuery';
import { CARLINE_QUERY } from './queries/carlineQuery';
import { getCaeDataForCarByCode } from './CaeUtils';
import { ConsumptionAndEmission } from './ConsumptionAndEmission';
export function isCarlineData(obj) {
    return (typeof obj === 'object' &&
        obj !== null &&
        obj &&
        typeof obj.carline === 'object' &&
        obj.carline !== null);
}
export const useConsumptionsAndEmissionsFromOneGraph = ({ ids, localeService, oneGraphService, logger, }) => {
    const oneGraphClient = oneGraphService?.getApolloClient();
    const [oneGraphData, setOneGraphData] = useState([]);
    const consumerId = `${__FEATURE_APP_NAME__}@${__FEATURE_APP_VERSION__}`;
    const context = { consumerId };
    const CarlineIdentifierInputs = useMemo(() => {
        return ids?.map((id) => {
            const isCarline = isCarLine(id);
            return {
                idType: isCarline ? 'carline' : 'audicode',
                query: isCarline ? CARLINE_QUERY : CAR_BY_CODE_QUERY,
                variables: isCarline
                    ? {
                        identifier: {
                            brand: localeService?.brand ?? 'A',
                            language: localeService?.language ?? '',
                            country: localeService?.countryCode ?? '',
                            id: id ?? '',
                        },
                    }
                    : { code: id },
            };
        });
    }, [localeService?.countryCode, ids]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!CarlineIdentifierInputs)
                    return;
                const responses = await Promise.all(CarlineIdentifierInputs?.map(async (input) => {
                    const response = await oneGraphClient
                        ?.query({
                        context,
                        variables: { ...input.variables },
                        query: input.query,
                    })
                        .catch((error) => {
                        logger?.error('Error! Fetching oneGraph consumptions and emissions data from feature-app-utils for carline id', input?.variables?.identifier?.id.toString(), error);
                        return { data: undefined };
                    });
                    return response?.data;
                }));
                if (responses !== undefined) {
                    setOneGraphData(responses);
                }
            }
            catch (error) {
                logger?.error('Error! fetching oneGraph consumptions and emissions data from feature-app-utils for ids', ids?.toString(), error);
            }
        };
        if (oneGraphClient) {
            fetchData().catch((err) => {
                logger?.error('[feature-app-utils] Server Error fetching from GraphQL:', err);
            });
        }
    }, [oneGraphClient, CarlineIdentifierInputs]);
    return oneGraphData;
};
export function ConsumptionsAndEmissions({ ids, localeService, oneGraphService, logger, }) {
    const data = useConsumptionsAndEmissionsFromOneGraph({
        ids,
        localeService,
        oneGraphService,
        logger,
    });
    if (!data)
        return null;
    return data?.map((d, index) => {
        const isCarline = isCarlineData(d);
        const caeDataForCarByCode = getCaeDataForCarByCode(d);
        return (React.createElement(ConsumptionAndEmission, { consumptionAndEmission: isCarline ? d?.carline?.consumptionAndEmission.summary : caeDataForCarByCode, key: isCarline ? 'carline' : `audicode${index}` }));
    });
}
//# sourceMappingURL=index.js.map